document.addEventListener('DOMContentLoaded', function() {
  function openNavSearch() {
    // HIDE SEARCHBAR
    document.getElementById('nav__search').classList.add('nav__search--hidden');

    // FLIP DESKTOP ICONS
    document
      .getElementById('nav__search--close')
      .classList.add('nav__search--hidden');
    document
      .getElementById('nav__search--open')
      .classList.remove('nav__search--hidden');

    // FLIP DESKTOP ICONS
    document
      .getElementById('nav__mobile__search--close')
      .classList.add('nav__mobile__search--hidden');
    document
      .getElementById('nav__mobile__search--open')
      .classList.remove('nav__mobile__search--hidden');
  }

  function closeNavSearch() {
    // SHOW SEARCHBAR
    document
      .getElementById('nav__search')
      .classList.remove('nav__search--hidden');

    // FLIP DESKTOP ICONS
    document
      .getElementById('nav__search--open')
      .classList.add('nav__search--hidden');
    document
      .getElementById('nav__search--close')
      .classList.remove('nav__search--hidden');

    // FLIP DESKTOP ICONS
    document
      .getElementById('nav__mobile__search--open')
      .classList.add('nav__mobile__search--hidden');
    document
      .getElementById('nav__mobile__search--close')
      .classList.remove('nav__mobile__search--hidden');
  }

  document
    .getElementById('nav__search--open')
    .addEventListener('click', () => closeNavSearch());
  document
    .getElementById('nav__mobile__search--open')
    .addEventListener('click', () => closeNavSearch());
  document
    .getElementById('nav__search--close')
    .addEventListener('click', () => openNavSearch());
  document
    .getElementById('nav__mobile__search--close')
    .addEventListener('click', () => openNavSearch());
});
